<template>
  <AdminLayout
    title="Dashboard"
    menu="Dashboard"
    :customStyle="{ backgroundColor: '#fcfcfc' }"
  >
    <title>DASHBOARD</title>
    <div class="row">
      <div class="col-lg-3">
        <div
          class="py-4 bg-aqua radius-4"
          ref="percentages"
        >
          <Percentages
            :recruiter_name="recruiter_info.name"
            :percentages="[
              percentage_converted_count,
              percentagem_contracted_count,
            ]"
          />
        </div>
      </div>
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-xs-12 radius-4">
            <div class="bg-aqua py-3 pl-3 pr-0 radius-4">
              <span class="f40 d-block">
                <b>{{ total_jobs_count }}</b>
              </span>
              <span class="f10 d-block">VAGAS</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-12 radius-4">
            <div class="bg-aqua py-3 pl-3 pr-0 radius-4">
              <span class="f40 d-inline">
                <b>{{ total_candidates }}</b>
              </span>
              <span class="f10 d-block">CANDIDATOS(AS)</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-12">
            <div class="bg-aqua py-3 pl-3 pr-0 radius-4">
              <span class="f40 d-block">
                <b>{{ total_contracted[0].total }}</b>
              </span>
              <span class="f10 d-block">CONTRATAÇÕES</span>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-12">
            <div
              class="py-3 pl-3 pr-0 color-white radius-4"
              style="background-color: #53358b"
            >
              <span class="f40 d-block">
                <b>{{ total_interviews }}</b>
              </span>
              <span class="f10 label-bold d-block">EM PROGRESSO</span>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="bg-aqua p-4 mt-4 radius-4">
              <span class="color-primary label-bold">ENGAJAMENTO DE CANDIDATOS(AS)</span>
              <Graph
                getFrom="/recruiters/applies_info"
                :height="graphHeight"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mt-4">
        <div class="bg-aqua p-3">
          <span class="font-weight-bold color-primary">Vagas Abertas</span>
          <div class="table-responsive mt-2">
            <table class="table table-borderless mb-0">
              <thead style="background-color: transparent; color: black">
                <tr>
                  <th></th>
                  <th class="f10">REPROVADO(A)S</th>
                  <th class="f10 px-0">NÃO SELECIONADO(A)S</th>
                  <th class="f10">SELECIONADO(A)S</th>
                  <th class="p-0"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="job in jobs"
                  :key="job.id"
                  class="h-auto"
                >
                  <th
                    width="35%"
                    class="pb-0 pl-0 center"
                    style="padding-top: 20px"
                  >
                    <inertia-link :href="'/recruiters/jobs/' + job.id + '/applies'">{{ job.title }}</inertia-link>
                  </th>
                  <td
                    width="20%"
                    class="pb-0 center"
                  >{{ job.reproved }}</td>
                  <td
                    width="20%"
                    class="pb-0 center pl-0"
                  >
                    {{ job.no_avaliation }}
                  </td>
                  <td
                    width="20%"
                    class="pb-0 center"
                  >{{ job.process }}</td>
                  <td
                    width="5%"
                    class="px-0"
                    style="padding-top: 20px"
                  >
                    <inertia-link :href="'/recruiters/jobs/' + job.id + '/applies'"><i
                        style="font-size: 25px"
                        class="fas fa-file-alt color-purple"
                      />
                    </inertia-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mt-4 d-flex flex-column justify-content-between">
        <div class="row">
          <div class="col-lg-6 radius-4">
            <div class="bg-aqua px-4 radius-4">
              <span class="font-large d-inline">
                <b>{{ open_jobs_count }}</b>
              </span>
              <div style="margin-top: -10px">
                <span class="d-inline">VAGAS ABERTAS</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 radius-4">
            <div class="bg-aqua px-4 radius-4">
              <span class="font-large d-inline">
                <b>{{ concluded_jobs_count }}</b>
              </span>
              <div style="margin-top: -10px">
                <span class="d-inline">VAGAS CONCLUÍDAS</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 radius-4">
            <div class="bg-aqua px-4 radius-4">
              <span class="font-large d-inline">
                <b>{{ total_interviews_count }}</b>
              </span>
              <div style="margin-top: -10px">
                <span class="d-inline">ENTREVISTAS</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 radius-4">
            <div class="bg-aqua px-4 radius-4">
              <span class="font-large d-inline">
                <b>{{ total_rated_count }}</b>
              </span>
              <div style="margin-top: -10px">
                <span class="d-inline">VIDEOS AVALIADOS</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AdminLayout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Graph from "components/Graph.vue";
import Percentages from "./Percentages.vue";
import AdminLayout from "layouts/AdminRecruiter.vue";
import Plan from "@/Recruiters/Plan/Index.vue";

export default {
  components: { AdminLayout, Graph, Percentages },
  props: [
    "total_videos",
    "total_jobs",
    "open_jobs",
    "clouse_jobs",
    "total_contracted",
    "avatar_url",
    "concluded_jobs",
    "total_candidates",
    "total_applies",
    "total_interviews",
    "total_rated",
    "recruiter_info",
    "job_incompleted",
    "percentage_converted",
    "candidate_aproved",
    "open_jobs_attr",
    "interview_open",
    "choose_plan",
    "candidates_in_progress",
  ],
  created() {
    localStorage.setItem("avatar-url", this.avatar_url);
  },
  mounted() {
    if (this.choose_plan) {
      this.$modal.show(
        Plan,
        {
          index: 0,
        },
        {
          width: "860px",
          height: "auto",
          scrollable: true,
          clickToClose: false,
        }
      );
    }

    this.percentagem_contracted = parseInt(
      (this.total_contracted[0].total * 100) / this.total_candidates
    );
    this.jobs = this.open_jobs_attr;

    this.chronometer("percentage_converted_count", "percentage_converted");
    this.chronometer("percentagem_contracted_count", "percentagem_contracted");
    this.chronometer("total_applies_count", "total_applies");
    this.chronometer("total_videos_count", "total_videos");
    this.chronometer("total_jobs_count", "total_jobs");
    this.chronometer("open_jobs_count", "open_jobs");
    this.chronometer("total_rated_count", "total_rated");
    this.chronometer("total_interviews_count", "total_interviews");
    this.chronometer("concluded_jobs_count", "concluded_jobs");

    this.onOff();

    this.graphHeight = this.$refs.percentages.clientHeight - 205;
  },
  watch: {},
  data: () => ({
    datacollection: {},
    recruiter: {
      name: "",
    },
    show_selective_process: true,
    marginMobile: "marginMobile",
    widthScreen: 0,
    percentagem_contracted: "",
    percentagem_contracted_count: 0,
    percentage_converted_count: 0,
    total_applies_count: 0,
    total_videos_count: 0,
    total_jobs_count: 0,
    open_jobs_count: 0,
    total_rated_count: 0,
    total_interviews_count: 0,
    concluded_jobs_count: 0,
    total_contracted_count: 0,
    jobs: [],
    graphHeight: 0,
  }),
  computed: {},
  methods: {
    onOff() {
      this.widthScreen = window.innerWidth;
      if (this.widthScreen > 750) {
        this.show_selective_process = true;
        this.marginMobile = true;
      } else {
        this.show_selective_process = false;
        this.marginMobile = false;
      }
    },
    chronometer(initial, final) {
      setInterval(() => {
        if (this[initial] < this[final]) {
          this[initial] += 1;
        } else {
          return;
        }
      }, 10);
    },
    logout() {
      axios
        .delete("/recruiters/sign_out")
        .then((resource) => {
          window.location = "/";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
  },
};
</script>
<style>
.small {
  width: 100%;
  height: 50vh;
}
</style>